import {useParams} from "react-router-dom";

import useDetailsAction from "../actions/details/useDetailsAction";
import { Card } from "react-bootstrap";
import {t} from "i18next";
import {useEffect} from "react";

function OrderDetailPage(props: any) {
  const { filters, formDefaultValues } = props;

  let {orderId} = useParams();

  if (!orderId) {
    orderId = "0";
  }

  const {
    getFunction,
    actionTemplate,
    changeStatusActionTemplate,
    uploadInvoiceActionTemplate,
  } = useDetailsAction(parseInt(orderId));

  useEffect(() => {
    if (!orderId ) return;
    getFunction(orderId);
  }, [orderId])

  return (
      <Card>
        <Card.Header>
          <Card.Title>{t("order")}</Card.Title>
        </Card.Header>

        <Card.Body>
          {actionTemplate}
          {changeStatusActionTemplate}
          {uploadInvoiceActionTemplate}
        </Card.Body>
      </Card>
  );
}

export default OrderDetailPage;
